import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AppShell from "../layouts/AppShell";
import { appBank, appModules } from "../components/global";
import Switch from "react-switch";
import { GET, POST, PUT, DELETE, loading, alert, Select, copyText, format_date, profile, DateInput } from "../components/CustomComponent";
import AssetLibrary from "../components/pdf-editor/AssetLibrary";
import provinceData from "../assets/files/th_province.json";

const companyFormDefaults = {
  name_th: "",
  name_en: "",
  tax_number: "",
  phone: "",
  email: "",
  website: "",
  address: "",
  province: "",
  district: "",
  sub_district: "",
  zip_code: "",
  logo: "",
  description: "",
  bank_name: "",
  bank_account_number: "",
  bank_account_name: "",
};

const financeCategoryFormDefaults = {
  uid: "",
  category_code: "",
  category_name: "",
  transaction_type: "expense",
  description: "",
  exclude_from_employee_report: false,
  is_active: true,
};

const roleFormDefaults = {
  uid: "",
  name: "",
  permission: [],
};

const userFormDefaults = {
  uid: "",
  role_id: "",
  employees_id: "",
  user_type: "employee",
  full_name_th: "",
  full_name_en: "",
  phone: "",
  email: "",
  password: "",
  is_active: true,
};

const holidayFormDefaults = {
  uid: "",
  holiday_date: "",
  name: "",
  holiday_type: "public",
  description: "",
  is_active: true,
};

const holidayTypeOptions = [
  { value: "public", label: "วันหยุดนักขัตฤกษ์" },
  { value: "company", label: "วันหยุดบริษัท" },
  { value: "special", label: "วันหยุดชดเชย/กรณีพิเศษ" },
];

const holidayTypeStyle = {
  public: { background: "rgba(229, 83, 83, 0.14)", color: "#b63636" },
  company: { background: "rgba(12, 117, 230, 0.14)", color: "#0b4f84" },
  special: { background: "rgba(245, 166, 35, 0.16)", color: "#b97007" },
};

const THAI_MONTH_NAMES = [
  "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
  "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",
];

const userTypeOptions = [
  { value: "admin", label: "ผู้ดูแลระบบ (admin)" },
  { value: "employee", label: "พนักงาน (employee)" },
  { value: "guest", label: "ผู้ใช้ทั่วไป (guest)" },
];

// prefix ต้องตรงกับ migration 20260811000700-seed-permission-keys.js และ moduleKey ใน global.js
// ถ้าเพิ่ม prefix ที่นี่โดยไม่ seed ลงตาราง permissions การบันทึก role จะ error "Permission not found"
// จัดกลุ่มและเรียงลำดับตามหัวข้อเมนูใน navbar (appGlobal.menu ใน global.js) ให้หาโมดูลได้ตรงกับที่เห็นในเมนู
const permissionSections = [
  {
    title: "Overview",
    icon: "fa-solid fa-house",
    groups: [
      // หน้าแรกเข้าได้ทุกคน ไม่ต้องตั้งสิทธิ์ (Navbar ใส่ welcome.read ให้ทุก role อัตโนมัติ)
      // { label: "หน้าแรก (Welcome)", prefix: "welcome" },
      { label: "Dashboard", prefix: "dashboard" },
    ],
  },
  {
    title: "Work",
    icon: "fa-solid fa-diagram-project",
    groups: [
      { label: "ทะเบียนโปรเจค", prefix: "projects" },
      { label: "ไฟล์ ENV ของโปรเจค (super_user + Authenticator)", prefix: "project_env_vars" },
      { label: "ไทม์ไลน์โปรเจค", prefix: "project_timelines" },
      { label: "งานในโปรเจค", prefix: "project_tasks" },
      { label: "สัญญา MA", prefix: "ma_contracts" },
    ],
  },
  {
    title: "Workforce",
    icon: "fa-solid fa-users",
    groups: [
      { label: "พนักงาน (Employees)", prefix: "employees" },
      { label: "เวลาเข้าออกงาน (Attendance)", prefix: "attendance" },
      { label: "การลา (Leaves)", prefix: "leaves" },
      { label: "วันหยุดบริษัท (Holidays)", prefix: "holidays" },
    ],
  },
  {
    title: "Finance",
    icon: "fa-solid fa-coins",
    groups: [
      { label: "เงินเดือน (Payroll)", prefix: "payroll" },
      // { label: "สลิปเงินเดือน (Payslips)", prefix: "payslips" },
      // { label: "ค่าล่วงเวลา (Overtime)", prefix: "overtime" },
      // { label: "ภาษีบริษัท (Tax)", prefix: "tax" },
      // { label: "ประกันสังคม", prefix: "social-security" },
      { label: "ธุรกรรมการเงิน", prefix: "finance_transactions" },
      { label: "หมวดหมู่การเงิน", prefix: "finance_categories" },
      { label: "เอกสารการเงิน", prefix: "company_documents" },
    ],
  },
  {
    title: "Operations",
    icon: "fa-solid fa-boxes-stacked",
    groups: [
      // { label: "ทรัพย์สินบริษัท (Assets)", prefix: "assets" },
      // { label: "จัดซื้อ (Procurement)", prefix: "procurement" },
      { label: "ไฟล์ข้อมูลบริษัท (Drive)", prefix: "drive" },
      { label: "ไฟล์เอกสาร (Documents)", prefix: "documents" },
      { label: "ลูกค้า / คู่ค้า (Partners)", prefix: "partners" },
      // { label: "ประกาศภายใน", prefix: "announcements" },
    ],
  },
  {
    title: "System",
    icon: "fa-solid fa-gear",
    groups: [
      { label: "ตั้งค่าระบบ", prefix: "setting" },
      { label: "ข้อมูลองค์กร (Companies)", prefix: "companies" },
      { label: "บัญชีผู้ใช้ (Users)", prefix: "users" },
      { label: "บทบาท (Roles)", prefix: "roles" },
      { label: "สิทธิ์ (Permissions)", prefix: "permissions" },
      { label: "ประวัติการใช้งาน (Audit Logs)", prefix: "audit_logs" },
    ],
  },
];

const permissionGroups = permissionSections.flatMap((section) => section.groups);

const PERMISSION_ACTIONS = ["read", "create", "update", "delete"];

// key ทั้งหมดที่ตารางสิทธิ์ในหน้านี้แสดง checkbox ให้ติ๊ก
// ต้องมีอยู่ในตาราง permissions ฝั่ง backend ไม่งั้นบันทึก role แล้วได้ "Permission not found"
const getGroupPermissionKeys = (group) => PERMISSION_ACTIONS.map((action) => `${group.prefix}.${action}`);

const ALL_PERMISSION_KEYS = permissionGroups.flatMap(getGroupPermissionKeys);

// บทบาทระบบที่ถือสิทธิ์สูงสุด: ลบไม่ได้ และแก้ได้เฉพาะผู้ใช้ที่ user_type = super_user (backend กันไว้อีกชั้น)
const SUPER_USER_ROLE = "super_user";
const canEditSuperUserRole = profile?.user_type === SUPER_USER_ROLE;

// checkbox "เลือกทั้งหมด" ที่มีสถานะกึ่งกลาง (เลือกไว้บางส่วน) ซึ่งต้องตั้งผ่าน DOM property เท่านั้น
const SelectAllCheckbox = ({ keys, selected, onToggle, label, id }) => {
  const checkedCount = keys.filter((key) => selected.includes(key)).length;
  const isAll = keys.length > 0 && checkedCount === keys.length;

  return (
    <input
      type="checkbox"
      id={id}
      className="form-check-input stg-perm-check"
      checked={isAll}
      ref={(element) => {
        if (element) element.indeterminate = checkedCount > 0 && !isAll;
      }}
      onChange={() => onToggle(keys, !isAll)}
      aria-label={label}
      title={label}
    />
  );
};

// เมนูของหน้าตั้งค่า: key ใช้สลับแท็บ ส่วนที่เหลือใช้แสดงผลในเมนูซ้ายและหัวแผงเนื้อหา
const settingsTabs = [
  { key: "company", icon: "fa-solid fa-building", label: "ข้อมูลองค์กร", hint: "ชื่อ ที่อยู่ บัญชีธนาคาร", eyebrow: "Company Profile", title: "ข้อมูลพื้นฐานของบริษัท", description: "ข้อมูลนี้ถูกนำไปใช้ในเอกสาร สลิปเงินเดือน และรายงานของระบบ" },
  { key: "finance-categories", icon: "fa-solid fa-tags", label: "หมวดหมู่ทางการเงิน", hint: "จัดกลุ่มรายรับ-รายจ่าย", eyebrow: "Finance", title: "หมวดหมู่ทางการเงิน", description: "จัดกลุ่มรายการรายรับและรายจ่ายที่ใช้ในธุรกรรมการเงิน" },
  { key: "expense-limits", icon: "fa-solid fa-wallet", label: "วงเงินเบิกค่าใช้จ่าย", hint: "วงเงินกลางและเฉพาะราย", eyebrow: "Finance", title: "วงเงินเบิกค่าใช้จ่ายต่อเดือน", description: "กำหนดยอดที่พนักงานเบิกค่าใช้จ่ายได้ต่อเดือน ระบบจะแจ้งเตือนเมื่อยอดเบิกเกินวงเงิน" },
  { key: "roles", icon: "fa-solid fa-user-shield", label: "สิทธิ์ผู้ใช้งาน (Roles)", hint: "บทบาทและสิทธิ์เข้าถึง", eyebrow: "Access Control", title: "สิทธิ์ผู้ใช้งาน (Roles)", description: "ถ้าบันทึกแล้วขึ้น \"Permission not found\" ให้กดซิงก์รายการสิทธิ์ก่อน" },
  { key: "users", icon: "fa-solid fa-users", label: "บัญชีผู้ใช้ (Users)", hint: "บัญชีเข้าใช้ระบบ", eyebrow: "Access Control", title: "บัญชีผู้ใช้ (Users)", description: "สร้างบัญชีเข้าใช้ระบบ กำหนดบทบาท และผูกกับข้อมูลพนักงาน" },
  { key: "drive-assets", icon: "fa-solid fa-stamp", label: "ตราปั๊มบริษัท & ลายเซ็น", hint: "คลังใช้แทรกตอนแก้ PDF", eyebrow: "Documents", title: "ตราปั๊มบริษัท & ลายเซ็น", description: "คลังนี้ใช้เลือกแทรกลงเอกสารตอนแก้ PDF ในหน้าไฟล์ข้อมูลบริษัท เพิ่มได้หลายอัน" },
  { key: "holidays", icon: "fa-solid fa-calendar-days", label: "วันหยุดบริษัท", hint: "ปฏิทินวันหยุดรายปี", eyebrow: "Calendar", title: "ปฏิทินวันหยุดบริษัท", description: "" },
];

const transactionTypeOptions = [
  { value: "income", label: "รายรับ" },
  { value: "expense", label: "รายจ่าย" },
];

const switchProps = { onColor: "#0c75e6", offColor: "#b7cadb", height: 26, width: 52 };

// เมนูซ้ายจะ sticky เฉพาะจอ >= lg (ดูคลาส .settings-sidebar-sticky ใน style.css)
// บนมือถือเมนูกลายเป็นแถบแท็บเลื่อนแนวนอนอยู่บนสุดของหน้า

// หัว thead sticky ของตารางในกรอบนี้กำหนดไว้ที่ .stg-table-wrap.settings-table-scroll ใน style.css
const settingsTableScrollStyle = {
  maxHeight: "65vh",
  overflowY: "auto",
  overflowX: "auto",
  msOverflowStyle: "none",
  scrollbarWidth: "none",
};

// หัวและท้าย modal ที่ใช้ร่วมกันทุกฟอร์มในหน้านี้ (สไตล์อยู่ที่ .stg-modal ใน style.css)
const SettingsModalHeader = ({ eyebrow, title, subtitle }) => (
  <Modal.Header closeButton>
    <div>
      <p className="stg-eyebrow">{eyebrow}</p>
      <Modal.Title>{title}</Modal.Title>
      {subtitle ? <p className="stg-modal-sub">{subtitle}</p> : null}
    </div>
  </Modal.Header>
);

const SettingsModalFooter = ({ onHide, onSave }) => (
  <Modal.Footer>
    <div className="stg-modal-actions">
      <button type="button" className="btn stg-btn stg-btn--ghost" onClick={onHide}>
        ยกเลิก
      </button>
      <button type="button" className="btn stg-btn stg-btn--primary" onClick={onSave}>
        <i className="fa-solid fa-floppy-disk" />บันทึกข้อมูล
      </button>
    </div>
  </Modal.Footer>
);

const provinceOptions = provinceData.map((item) => item.th);

/* --------------------- วงเงินเบิกค่าใช้จ่ายต่อเดือน (helpers) -------------------- */

const formatMoneyText = (value) => {
  const num = Number(String(value ?? "").replace(/,/g, ""));
  if (!Number.isFinite(num)) return "0.00";
  return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// 0 หรือค่าว่าง = ไม่จำกัดวงเงิน
const formatLimitText = (value) => (Number(value) > 0 ? `฿ ${formatMoneyText(value)}` : "ไม่จำกัด");

// ค่าที่ได้จาก API เป็น string ทศนิยม (เช่น "10000.00") แปลงให้กรอกในฟอร์มอ่านง่าย
const toLimitInput = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const num = Number(value);
  return Number.isFinite(num) ? String(num) : "";
};

const isValidLimitInput = (value) => {
  if (String(value).trim() === "") return true;
  const num = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(num) && num >= 0;
};

const getEmployeeName = (employee) => {
  const fullName = `${employee?.first_name || ""} ${employee?.last_name || ""}`.trim();
  return fullName || employee?.nickname || employee?.employee_code || "-";
};

const bankImageContext = require.context("../assets/images/bank", false, /\.(png|jpe?g|svg)$/);

// webpack 5 คืนไฟล์รูปเป็น ES module ({ default: url }) ต้องดึง .default ออกมา
// ไม่งั้น src จะกลายเป็น "[object Module]" แล้วรูปไม่ขึ้น
const getBankImage = (icon) => {
    try {
        const asset = bankImageContext(`./${icon}`);
        return asset?.default || asset || null;
    } catch (error) {
        return null;
    }
};

const bankOptions = appBank.map((bank) => {
  const image = getBankImage(bank.icon);
  return {
    value: bank.value,
    label: bank.name_th || bank.label,
    front: image ? (
      <img
        src={image}
        alt={bank.label}
        style={{
          width: 22,
          height: 22,
          objectFit: "contain",
          marginRight: 8,
          borderRadius: 999,
          background: "#ffffff",
        }}
      />
    ) : null,
  };
});

const RoleModal = ({ show, onHide, editData, onSave }) => {
  const [formData, setFormData] = useState(roleFormDefaults);

  useEffect(() => {
    setFormData({
      ...roleFormDefaults,
      uid: editData?.uid || "",
      name: editData?.name || "",
      // กรองเหลือเฉพาะ key ที่ตารางสิทธิ์ด้านล่างมี checkbox ให้ติ๊กจริง
      // ไม่งั้น key ของโมดูลที่เลิกใช้แล้วจะถูกบันทึกกลับไปเรื่อย ๆ ทั้งที่มองไม่เห็น
      permission: Array.isArray(editData?.permission)
        ? editData.permission.filter((key) => ALL_PERMISSION_KEYS.includes(key))
        : [],
    });
  }, [editData, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTogglePermission = (permission) => {
    setFormData((prev) => {
      const hasPermission = prev.permission.includes(permission);
      return {
        ...prev,
        permission: hasPermission
          ? prev.permission.filter((item) => item !== permission)
          : [...prev.permission, permission],
      };
    });
  };

  // ติ๊ก/ล้างหลาย key พร้อมกัน ใช้กับ "เลือกทั้งหมด" ระดับแถว ระดับหัวข้อ และทั้งตาราง
  const handleTogglePermissionKeys = (keys, checked) => {
    setFormData((prev) => ({
      ...prev,
      permission: checked
        ? [...new Set([...prev.permission, ...keys])]
        : prev.permission.filter((item) => !keys.includes(item)),
    }));
  };

  const isSuperUserRole = editData?.name === SUPER_USER_ROLE;

  return (
    <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="stg-modal modal-dialog-scrollable">
      <SettingsModalHeader
        eyebrow="Role & Permissions"
        title={editData ? "แก้ไขสิทธิ์ผู้ใช้งาน (Role)" : "เพิ่มบทบาทใหม่"}
        subtitle={editData ? "อัปเดตสิทธิ์ผู้ใช้งานและการเข้าถึงระบบ" : "สร้างบทบาทใหม่และกำหนดสิทธิ์ได้ทันที"}
      />

      <Modal.Body>
        <form>
          <div className="stg-section">
            <div className="stg-section-head">
              <span className="stg-section-mark"><i className="fa-solid fa-user-tag" /></span>
              <div>
                <h4 className="stg-section-title">ข้อมูลบทบาท</h4>
                <p className="stg-section-desc">กำหนดชื่อบทบาทและสิทธิ์ที่เกี่ยวข้องสำหรับผู้ใช้งาน</p>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-8">
                <label className="stg-label">ชื่อบทบาท</label>
                {/* ชื่อ super_user ถูกอ้างถึงในโค้ดหลายจุด จึงล็อกไม่ให้เปลี่ยน */}
                <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} placeholder="เช่น hr_manager" disabled={isSuperUserRole} />
              </div>
              <div className="col-md-4">
                <label className="stg-label">จำนวนสิทธิ์</label>
                <input type="text" className="form-control" value={`${formData.permission.length} / ${ALL_PERMISSION_KEYS.length}`} disabled />
              </div>
            </div>
          </div>

          <div className="stg-section">
            <div className="stg-section-head">
              <span className="stg-section-mark"><i className="fa-solid fa-key" /></span>
              <div>
                <h4 className="stg-section-title">สิทธิ์การเข้าถึง</h4>
                <p className="stg-section-desc">เลือกสิทธิ์การเข้าถึงสำหรับบทบาทนี้อย่างละเอียด</p>
              </div>
            </div>
            <label className="stg-perm-all" htmlFor="perm-all">
              <SelectAllCheckbox id="perm-all" keys={ALL_PERMISSION_KEYS} selected={formData.permission} onToggle={handleTogglePermissionKeys} label="เลือกสิทธิ์ทั้งหมดทุกหัวข้อ" />
              <span className="stg-toggle-title">เลือกทั้งหมดทุกหัวข้อ</span>
              <span className="stg-pill stg-pill--info stg-pill--plain ms-auto">{formData.permission.length} / {ALL_PERMISSION_KEYS.length}</span>
            </label>

            {permissionSections.map((section) => {
              const sectionKeys = section.groups.flatMap(getGroupPermissionKeys);
              const sectionCount = sectionKeys.filter((key) => formData.permission.includes(key)).length;
              const sectionId = `perm-section-${section.title}`;

              return (
                <div className="stg-perm-section" key={section.title}>
                  <div className="stg-perm-section-head">
                    <span className="stg-perm-section-icon"><i className={section.icon} /></span>
                    <span className="stg-perm-section-title">{section.title}</span>
                    <span className="stg-perm-section-count">{sectionCount} / {sectionKeys.length}</span>
                    <label className="stg-perm-section-all" htmlFor={sectionId}>
                      <SelectAllCheckbox id={sectionId} keys={sectionKeys} selected={formData.permission} onToggle={handleTogglePermissionKeys} label={`เลือกทั้งหมดในหัวข้อ ${section.title}`} />
                      เลือกทั้งหมด
                    </label>
                  </div>
                  <div className="table-responsive table-mobile-cards stg-table-wrap">
                    <table className="table table-hover align-middle stg-table stg-perm-table">
                      <thead>
                        <tr>
                          <th>เมนู / โมดูล</th>
                          <th className="text-center">ทั้งแถว</th>
                          <th className="text-center">Read</th>
                          <th className="text-center">Create</th>
                          <th className="text-center">Update</th>
                          <th className="text-center">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {section.groups.map((group) => (
                          <tr key={group.prefix}>
                            <td data-label="เมนู / โมดูล" className="stg-cell-title stg-cell-wrap">{group.label}</td>
                            <td data-label="ทั้งแถว" className="text-center">
                              <SelectAllCheckbox keys={getGroupPermissionKeys(group)} selected={formData.permission} onToggle={handleTogglePermissionKeys} label={`เลือกสิทธิ์ทั้งหมดของ ${group.label}`} />
                            </td>
                            {PERMISSION_ACTIONS.map((action) => {
                              const permissionKey = `${group.prefix}.${action}`;
                              return (
                                <td key={permissionKey} data-label={action.charAt(0).toUpperCase() + action.slice(1)} className="text-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input stg-perm-check"
                                    checked={formData.permission.includes(permissionKey)}
                                    onChange={() => handleTogglePermission(permissionKey)}
                                    aria-label={`${group.label} ${action}`}
                                  />
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        </form>
      </Modal.Body>

      <SettingsModalFooter onHide={onHide} onSave={() => onSave(formData)} />
    </Modal>
  );
};

const FinanceCategoryModal = ({ show, onHide, editData, onSave }) => {
  const [formData, setFormData] = useState(financeCategoryFormDefaults);

  useEffect(() => {
    setFormData({
      ...financeCategoryFormDefaults,
      ...editData,
      uid: editData?.uid || "",
      transaction_type: editData?.transaction_type || "expense",
      exclude_from_employee_report: editData?.exclude_from_employee_report ?? false,
      is_active: editData?.is_active ?? true,
    });
  }, [editData, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleToggleActive = (checked) => {
    setFormData((prev) => ({
      ...prev,
      is_active: checked,
    }));
  };

  const handleToggleExcludeFromEmployeeReport = (checked) => {
    setFormData((prev) => ({
      ...prev,
      exclude_from_employee_report: checked,
    }));
  };

  const displayCategoryName = formData.category_name || editData?.category_name || "สร้างหมวดหมู่ทางการเงินใหม่";

  return (
    <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="stg-modal modal-dialog-scrollable">
      <SettingsModalHeader
        eyebrow="Finance Category"
        title={editData ? "แก้ไขหมวดหมู่ทางการเงิน" : "เพิ่มหมวดหมู่ทางการเงิน"}
        subtitle={editData ? "อัปเดตข้อมูลหมวดหมู่ทางการเงินให้เป็นปัจจุบัน" : "กำหนดหมวดหมู่สำหรับจัดระเบียบรายการรายรับและรายจ่าย"}
      />

      <Modal.Body>
        <div className="stg-toggle-row mb-3">
          <div style={{ minWidth: 0 }}>
            <div className="stg-toggle-title text-truncate">{displayCategoryName}</div>
            <div className="stg-toggle-note">{formData.is_active ? "พร้อมใช้งาน" : "ปิดใช้งาน"}</div>
          </div>
          <Switch checked={formData.is_active} onChange={handleToggleActive} {...switchProps} id="isActiveFinanceCategory" />
        </div>

        <form>
          <div className="stg-section">
            <div className="stg-section-head">
              <span className="stg-section-mark"><i className="fa-solid fa-tags" /></span>
              <div>
                <h4 className="stg-section-title">ข้อมูลหมวดหมู่</h4>
                <p className="stg-section-desc">รายละเอียดหมวดหมู่ที่ใช้จัดกลุ่มรายการทางการเงินในระบบ</p>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="stg-label">รหัสหมวดหมู่</label>
                <input type="text" name="category_code" className="form-control" value={formData.category_code} onChange={handleChange} placeholder="เช่น EXP-001" />
              </div>
              <div className="col-md-6">
                <label className="stg-label">ชื่อหมวดหมู่</label>
                <input type="text" name="category_name" className="form-control" value={formData.category_name} onChange={handleChange} placeholder="ระบุชื่อหมวดหมู่" />
              </div>
              <div className="col-md-6">
                <label className="stg-label">ประเภทรายการ</label>
                <Select
                  className="form-control"
                  value={formData.transaction_type}
                  options={transactionTypeOptions}
                  default={false}
                  onChange={(value) => handleChange({ target: { name: "transaction_type", value } })}
                />
              </div>
              <div className="col-12">
                <label className="stg-label">ไม่รวมในรายงานธุรกรรมพนักงาน</label>
                <div className="stg-toggle-row">
                  <div>
                    <div className="stg-toggle-title">{formData.exclude_from_employee_report ? "ไม่รวมในรายงาน" : "รวมในรายงาน"}</div>
                    <div className="stg-toggle-note">เปิดไว้สำหรับหมวดหมู่ที่ไม่ใช่ค่าใช้จ่ายส่วนตัวของพนักงาน</div>
                  </div>
                  <Switch
                    checked={!!formData.exclude_from_employee_report}
                    onChange={handleToggleExcludeFromEmployeeReport}
                    {...switchProps}
                    id="excludeFromEmployeeReportFinanceCategory"
                  />
                </div>
              </div>
              <div className="col-12">
                <label className="stg-label">รายละเอียด</label>
                <textarea
                  name="description"
                  className="form-control"
                  style={{ minHeight: 108, resize: "none" }}
                  rows="3"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="รายละเอียดเพิ่มเติมของหมวดหมู่"
                ></textarea>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>

      <SettingsModalFooter onHide={onHide} onSave={() => onSave(formData)} />
    </Modal>
  );
};

// จัดการบัญชีผู้ใช้: สร้าง/แก้ไข ผูกกับพนักงาน กำหนดบทบาทและสถานะใช้งาน
const UserModal = ({ show, onHide, editData, onSave, roleOptions = [], employeeOptions = [] }) => {
  const [formData, setFormData] = useState(userFormDefaults);

  useEffect(() => {
    setFormData({
      ...userFormDefaults,
      uid: editData?.uid || "",
      role_id: editData?.role?.uid || "",
      employees_id: editData?.employee?.uid || "",
      user_type: editData?.user_type || "employee",
      full_name_th: editData?.full_name_th || "",
      full_name_en: editData?.full_name_en || "",
      phone: editData?.phone || "",
      email: editData?.email || "",
      password: "",
      is_active: editData ? !!editData.is_active : true,
    });
  }, [editData, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const displayName = formData.full_name_th || formData.full_name_en || (editData ? "แก้ไขบัญชีผู้ใช้" : "บัญชีผู้ใช้ใหม่");

  return (
    <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="stg-modal modal-dialog-scrollable">
      <SettingsModalHeader
        eyebrow="User Account"
        title={editData ? "แก้ไขบัญชีผู้ใช้" : "เพิ่มบัญชีผู้ใช้"}
        subtitle={editData ? "อัปเดตข้อมูลบัญชีและสิทธิ์การเข้าใช้งาน" : "สร้างบัญชีใหม่พร้อมกำหนดบทบาทและผูกกับข้อมูลพนักงาน"}
      />

      <Modal.Body>
        <div className="stg-toggle-row mb-3">
          <div className="d-flex align-items-center gap-3" style={{ minWidth: 0 }}>
            <span className="stg-avatar">{String(displayName).trim().charAt(0).toUpperCase() || "U"}</span>
            <div style={{ minWidth: 0 }}>
              <div className="stg-toggle-title text-truncate">{displayName}</div>
              <div className="stg-toggle-note">{formData.is_active ? "เข้าใช้งานได้" : "ระงับการใช้งาน"}</div>
            </div>
          </div>
          <Switch
            checked={!!formData.is_active}
            onChange={(checked) => setFormData((current) => ({ ...current, is_active: checked }))}
            {...switchProps}
            id="isActiveUser"
          />
        </div>

        <form>
          <div className="stg-section">
            <div className="stg-section-head">
              <span className="stg-section-mark"><i className="fa-solid fa-user" /></span>
              <div>
                <h4 className="stg-section-title">ข้อมูลบัญชี</h4>
                <p className="stg-section-desc">ชื่อผู้ใช้ อีเมลสำหรับเข้าสู่ระบบ และรหัสผ่าน</p>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="stg-label">ชื่อ-นามสกุล (ไทย)</label>
                <input type="text" name="full_name_th" className="form-control" value={formData.full_name_th} onChange={handleChange} placeholder="เช่น สมชาย ใจดี" />
              </div>
              <div className="col-md-6">
                <label className="stg-label">ชื่อ-นามสกุล (อังกฤษ)</label>
                <input type="text" name="full_name_en" className="form-control" value={formData.full_name_en} onChange={handleChange} placeholder="เช่น Somchai Jaidee" />
              </div>
              <div className="col-md-6">
                <label className="stg-label">อีเมล (ใช้เข้าสู่ระบบ)</label>
                <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} placeholder="you@company.com" />
              </div>
              <div className="col-md-6">
                <label className="stg-label">เบอร์โทร</label>
                <input type="text" name="phone" className="form-control" value={formData.phone} onChange={handleChange} placeholder="0xx-xxx-xxxx" />
              </div>
              <div className="col-md-6">
                <label className="stg-label">
                  รหัสผ่าน {editData ? <span className="fw-normal text-secondary">(เว้นว่างไว้ถ้าไม่เปลี่ยน)</span> : ""}
                </label>
                <input type="password" name="password" className="form-control" value={formData.password} onChange={handleChange} placeholder="อย่างน้อย 8 ตัวอักษร" autoComplete="new-password" />
              </div>
            </div>
          </div>

          <div className="stg-section">
            <div className="stg-section-head">
              <span className="stg-section-mark"><i className="fa-solid fa-user-shield" /></span>
              <div>
                <h4 className="stg-section-title">สิทธิ์และการผูกข้อมูล</h4>
                <p className="stg-section-desc">ประเภทผู้ใช้ บทบาท และพนักงานที่บัญชีนี้เป็นเจ้าของ</p>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="stg-label">ประเภทผู้ใช้</label>
                <Select
                  className="form-control"
                  value={formData.user_type}
                  options={userTypeOptions}
                  default={false}
                  onChange={(value) => handleChange({ target: { name: "user_type", value } })}
                />
              </div>
              <div className="col-md-6">
                <label className="stg-label">บทบาท (Role)</label>
                <Select
                  className="form-control"
                  value={formData.role_id}
                  options={roleOptions}
                  placeholder="เลือกบทบาท"
                  onChange={(value) => setFormData((current) => ({ ...current, role_id: value }))}
                />
              </div>
              <div className="col-12">
                <label className="stg-label">ผูกกับพนักงาน</label>
                <Select
                  className="form-control"
                  value={formData.employees_id}
                  options={employeeOptions}
                  placeholder="ไม่ผูกกับพนักงาน"
                  onChange={(value) => setFormData((current) => ({ ...current, employees_id: value || "" }))}
                />
                <div className="stg-help">
                  ผูกไว้เพื่อให้บัญชีนี้ดูสลิปเงินเดือน ลงเวลาเข้างาน และเห็นข้อมูลส่วนตัวของตัวเองได้
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>

      <SettingsModalFooter onHide={onHide} onSave={() => onSave(formData)} />
    </Modal>
  );
};

// เพิ่ม/แก้ไขวันหยุดบริษัทหนึ่งวัน
const HolidayModal = ({ show, onHide, editData, onSave }) => {
  const [formData, setFormData] = useState(holidayFormDefaults);

  useEffect(() => {
    setFormData({
      ...holidayFormDefaults,
      uid: editData?.uid || "",
      holiday_date: editData?.holiday_date || editData?.presetDate || "",
      name: editData?.name || "",
      holiday_type: editData?.holiday_type || "public",
      description: editData?.description || "",
      is_active: editData ? editData.is_active !== false : true,
    });
  }, [editData, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="stg-modal">
      <SettingsModalHeader
        eyebrow="Company Holiday"
        title={editData?.uid ? "แก้ไขวันหยุด" : "เพิ่มวันหยุด"}
        subtitle="วันหยุดถูกใช้คำนวณวันทำงานของระบบการลาและเงินเดือน"
      />

      <Modal.Body>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="stg-label">วันที่</label>
            <DateInput name="holiday_date" className="form-control" value={formData.holiday_date} onChange={handleChange} />
          </div>
          <div className="col-md-6">
            <label className="stg-label">ประเภท</label>
            <Select
              className="form-control"
              value={formData.holiday_type}
              options={holidayTypeOptions}
              default={false}
              onChange={(value) => handleChange({ target: { name: "holiday_type", value } })}
            />
          </div>
          <div className="col-12">
            <label className="stg-label">ชื่อวันหยุด</label>
            <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} placeholder="เช่น วันสงกรานต์" />
          </div>
          <div className="col-12">
            <label className="stg-label">หมายเหตุ</label>
            <textarea name="description" className="form-control" rows={2} value={formData.description} onChange={handleChange} placeholder="รายละเอียดเพิ่มเติม (ถ้ามี)" />
          </div>
          <div className="col-12">
            <div className="stg-toggle-row">
              <div>
                <div className="stg-toggle-title">{formData.is_active ? "ใช้งานอยู่" : "ปิดใช้งาน"}</div>
                <div className="stg-toggle-note">ปิดไว้ถ้ายกเลิกวันหยุดนี้ โดยไม่ต้องการลบทิ้ง</div>
              </div>
              <Switch
                checked={!!formData.is_active}
                onChange={(checked) => setFormData((current) => ({ ...current, is_active: checked }))}
                {...switchProps}
                id="isActiveHoliday"
              />
            </div>
          </div>
        </div>
      </Modal.Body>

      <SettingsModalFooter onHide={onHide} onSave={() => onSave(formData)} />
    </Modal>
  );
};

export default function Settings() {
  const { title, description } = appModules["settings"];
  const [activeTab, setActiveTab] = useState("company");
  // คลังตราปั๊ม/ลายเซ็นใช้ระบบเดียวกับไฟล์ข้อมูลบริษัท (drive) จึงเช็คสิทธิ์ drive แบบเดียวกับเมนู
  const canManageDriveAssets = (() => {
    try {
      const permission = JSON.parse(localStorage.getItem("ptn-profile") || "{}")?.role?.permission;
      return Array.isArray(permission) && permission.includes("drive.read");
    } catch (error) {
      return false;
    }
  })();
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [editRoleData, setEditRoleData] = useState(null);
  const [roles, setRoles] = useState([]);
  const [showFinanceCategoryModal, setShowFinanceCategoryModal] = useState(false);
  const [editFinanceCategoryData, setEditFinanceCategoryData] = useState(null);
  const [companyForm, setCompanyForm] = useState(companyFormDefaults);
  const [financeCategories, setFinanceCategories] = useState([]);
  const [financeTypeFilter, setFinanceTypeFilter] = useState("all");
  const [expenseLimitDefault, setExpenseLimitDefault] = useState("");
  const [expenseLimitRows, setExpenseLimitRows] = useState([]);
  const [users, setUsers] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false);
  const [editUserData, setEditUserData] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [holidayYear, setHolidayYear] = useState(String(new Date().getFullYear()));
  const [showHolidayModal, setShowHolidayModal] = useState(false);
  const [editHolidayData, setEditHolidayData] = useState(null);

  const handleOpenRoleModal = (data = null) => {
    setEditRoleData(data);
    setShowRoleModal(true);
  };

  const handleCloseRoleModal = () => {
    setEditRoleData(null);
    setShowRoleModal(false);
  };

  const handleOpenFinanceCategoryModal = (data = null) => {
    setEditFinanceCategoryData(data);
    setShowFinanceCategoryModal(true);
  };

  const handleCloseFinanceCategoryModal = () => {
    setEditFinanceCategoryData(null);
    setShowFinanceCategoryModal(false);
  };

  const handleCompanyChange = (event) => {
    const { name, value } = event.target;
    setCompanyForm((prev) => {
      if (name === "province") {
        return {
          ...prev,
          province: value,
          district: "",
          sub_district: "",
          zip_code: "",
        };
      }

      if (name === "district") {
        return {
          ...prev,
          district: value,
          sub_district: "",
          zip_code: "",
        };
      }

      if (name === "sub_district") {
        const selectedProvince = provinceData.find((item) => item.th === prev.province);
        const selectedDistrict = selectedProvince?.district?.find((item) => item.th === prev.district);
        const selectedSubDistrict = selectedDistrict?.sub_district?.find((item) => item.th === value);

        return {
          ...prev,
          sub_district: value,
          zip_code: selectedSubDistrict ? String(selectedSubDistrict.code) : "",
        };
      }

      if (name === "zip_code") {
        return {
          ...prev,
          zip_code: value,
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getCompanyData = async () => {
    loading(true);
    let result = await GET("v1/admin/companies");
    if (result?.status) {
      const companyData = result.data || {};
      setCompanyForm({
        ...companyFormDefaults,
        ...companyData,
      });
    }
    loading(false);
  };

  const getFinanceCategories = async () => {
    loading(true);
    const result = await GET("v1/admin/finance-categories", { page: 0 });
    if (result?.status) {
      setFinanceCategories(result.data || []);
    }
    loading(false);
  };

  const getRoles = async () => {
    loading(true);
    const result = await GET("v1/admin/roles", { page: 1, page_size: 100 });
    if (result?.status) {
      setRoles(result.data || []);
    }
    loading(false);
  };

  const getExpenseLimits = async () => {
    loading(true);
    const result = await GET("v1/admin/employee-finance/expense-limits");
    if (result?.status) {
      const data = result.data || {};
      setExpenseLimitDefault(toLimitInput(data.default_limit));
      setExpenseLimitRows(
        (data.employees || []).map((item) => ({
          ...item,
          // ค่าว่าง = ยังไม่ตั้งเฉพาะคน ให้ใช้ค่ากลางของบริษัท
          input: toLimitInput(item.expense_monthly_limit),
        }))
      );
    }
    loading(false);
  };

  const handleExpenseLimitChange = (uid, value) => {
    setExpenseLimitRows((prev) => prev.map((row) => (row.employee?.uid === uid ? { ...row, input: value } : row)));
  };

  const updateExpenseLimits = async () => {
    if (!isValidLimitInput(expenseLimitDefault)) {
      await alert("", "warning", "แจ้งเตือน", "กรุณากรอกวงเงินกลางเป็นตัวเลขที่ไม่ติดลบ");
      return;
    }

    const invalidRow = expenseLimitRows.find((row) => !isValidLimitInput(row.input));
    if (invalidRow) {
      await alert("", "warning", "แจ้งเตือน", `กรุณากรอกวงเงินของ ${getEmployeeName(invalidRow.employee)} เป็นตัวเลขที่ไม่ติดลบ`);
      return;
    }

    if (await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")) {
      loading(true);
      const body = {
        default_limit: String(expenseLimitDefault).trim() === "" ? 0 : String(expenseLimitDefault).trim(),
        employees: expenseLimitRows
          .filter((row) => row.employee?.uid)
          .map((row) => ({
            uid: row.employee.uid,
            expense_monthly_limit: String(row.input).trim() === "" ? null : String(row.input).trim(),
          })),
      };

      const result = await PUT("v1/admin/employee-finance/expense-limits", body);
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        getExpenseLimits();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const handleOpenUserModal = (data = null) => {
    setEditUserData(data);
    setShowUserModal(true);
  };

  const handleCloseUserModal = () => {
    setEditUserData(null);
    setShowUserModal(false);
  };

  const getUsers = async () => {
    loading(true);
    const result = await GET("v1/admin/users", { page: 0 });
    if (result?.status) setUsers(result.data || []);
    loading(false);
  };

  const getEmployees = async () => {
    const result = await GET("v1/admin/employees", { page: 0 });
    if (result?.status) setEmployees(result.data || []);
  };

  const createUpdateUser = async (formData) => {
    if (!formData.full_name_th?.trim() || !formData.email?.trim()) {
      await alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ-นามสกุล (ไทย) และอีเมล");
      return;
    }
    if (!formData.role_id) {
      await alert("", "warning", "แจ้งเตือน", "กรุณาเลือกบทบาท (Role)");
      return;
    }
    if (!formData.uid && (formData.password || "").length < 8) {
      await alert("", "warning", "แจ้งเตือน", "กรุณากำหนดรหัสผ่านอย่างน้อย 8 ตัวอักษร");
      return;
    }
    if (formData.uid && formData.password && formData.password.length < 8) {
      await alert("", "warning", "แจ้งเตือน", "รหัสผ่านใหม่ต้องยาวอย่างน้อย 8 ตัวอักษร");
      return;
    }
    if (!(await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก"))) return;

    loading(true);
    // DTO เป็น strict schema ส่งเฉพาะฟิลด์ที่รับ และตัดรหัสผ่านออกถ้าไม่ได้กรอกตอนแก้ไข
    const body = {
      role_id: formData.role_id,
      employees_id: formData.employees_id || "",
      user_type: formData.user_type,
      full_name_th: formData.full_name_th.trim(),
      full_name_en: (formData.full_name_en || formData.full_name_th).trim(),
      phone: formData.phone?.trim() || undefined,
      email: formData.email.trim(),
      is_active: !!formData.is_active,
      ...(formData.password ? { password: formData.password } : {}),
    };

    const result = formData.uid
      ? await PUT(`v1/admin/users/${formData.uid}`, body)
      : await POST("v1/admin/users", body);

    if (result?.status === true) {
      alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
      getUsers();
      handleCloseUserModal();
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };

  const deleteUser = async (item) => {
    if (!(await alert("", "warning", "ลบบัญชีผู้ใช้", `ต้องการลบบัญชี ${item.email || ""} ?`, "ลบ", "ยกเลิก"))) return;

    loading(true);
    const result = await DELETE(`v1/admin/users/${item.uid}`);
    if (result?.status === true) {
      alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
      getUsers();
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };

  const handleOpenHolidayModal = (data = null) => {
    setEditHolidayData(data);
    setShowHolidayModal(true);
  };

  const handleCloseHolidayModal = () => {
    setEditHolidayData(null);
    setShowHolidayModal(false);
  };

  const getHolidays = async (year) => {
    loading(true);
    const result = await GET("v1/admin/holidays", { page: 0, year: year || holidayYear });
    if (result?.status) setHolidays(result.data || []);
    loading(false);
  };

  const createUpdateHoliday = async (formData) => {
    if (!formData.holiday_date || !formData.name?.trim()) {
      await alert("", "warning", "แจ้งเตือน", "กรุณากรอกวันที่และชื่อวันหยุด");
      return;
    }
    if (!(await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก"))) return;

    loading(true);
    const body = {
      holiday_date: formData.holiday_date,
      name: formData.name.trim(),
      holiday_type: formData.holiday_type,
      description: formData.description?.trim() || undefined,
      is_active: !!formData.is_active,
    };

    const result = formData.uid
      ? await PUT(`v1/admin/holidays/${formData.uid}`, body)
      : await POST("v1/admin/holidays", body);

    if (result?.status === true) {
      alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
      getHolidays();
      handleCloseHolidayModal();
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };

  const deleteHoliday = async (item) => {
    if (!(await alert("", "warning", "ลบวันหยุด", `ต้องการลบ "${item.name}" ?`, "ลบ", "ยกเลิก"))) return;

    loading(true);
    const result = await DELETE(`v1/admin/holidays/${item.uid}`);
    if (result?.status === true) {
      alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
      getHolidays();
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };

  const deleteRole = async (uid) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบสิทธิ์นี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      const result = await DELETE(`v1/admin/roles/${uid}`);
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        getRoles();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  useEffect(() => {
    getCompanyData();
    getFinanceCategories();
    getRoles();
    getExpenseLimits();
    getUsers();
    getEmployees();
  }, []);

  useEffect(() => {
    getHolidays(holidayYear);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [holidayYear]);

  const updateCompanyData = async () => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      // วงเงินเบิกค่าใช้จ่ายแก้ที่แท็บ "วงเงินเบิกค่าใช้จ่าย" เท่านั้น กันค่าเก่าในฟอร์มทับค่าที่เพิ่งตั้งไว้
      const { expense_monthly_limit, ...companyPayload } = companyForm;
      let result = await PUT(`v1/admin/companies`, companyPayload);

      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        getCompanyData();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  // สร้าง permission key ที่ยังไม่มีในตารางให้ครบ (backend ใช้ findOrCreate จึงเรียกซ้ำได้)
  // ใช้ตอนเพิ่มโมดูลใหม่แล้วยังไม่ได้รัน migration seed
  const syncPermissionKeys = async () => {
    const result = await POST("v1/admin/roles/permission", { permission_key: ALL_PERMISSION_KEYS });
    return result?.status === true;
  };

  const handleSyncPermissions = async () => {
    if (!(await alert("", "info", "ซิงก์รายการสิทธิ์", `เพิ่มสิทธิ์ที่ยังไม่มีในระบบให้ครบ ${ALL_PERMISSION_KEYS.length} รายการ?`, "ซิงก์", "ยกเลิก"))) return;

    loading(true);
    const ok = await syncPermissionKeys();
    loading(false);

    await alert("", ok ? "success" : "warning", ok ? "สำเร็จ" : "แจ้งเตือน", ok ? "ซิงก์รายการสิทธิ์เรียบร้อย" : "ซิงก์ไม่สำเร็จ");
  };

  const handleRoleSave = async (formData) => {
    const requiredFields = [
      { key: "name", label: "ชื่อบทบาท" },
    ];

    const missingField = requiredFields.find(({ key }) => {
      const value = formData?.[key];
      return value === undefined || value === null || String(value).trim() === "";
    });

    if (missingField) {
      await alert("", "warning", "แจ้งเตือน", `กรุณากรอกข้อมูล ${missingField.label}`);
      return;
    }

    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      const uid = formData?.uid;
      const body = {
        name: formData.name,
        permission: formData.permission,
      };

      const saveRole = () => (!uid ? POST("v1/admin/roles", body) : PUT(`v1/admin/roles/${uid}`, body));

      let result = await saveRole();

      // สิทธิ์ที่ติ๊กไว้ยังไม่มีในตาราง (เพิ่งเพิ่มโมดูลใหม่ / ยังไม่ได้รัน migration seed)
      // สร้าง key ให้ครบแล้วลองบันทึกอีกครั้ง
      if (result?.status !== true && String(result?.message || "").includes("Permission not found")) {
        if (await syncPermissionKeys()) result = await saveRole();
      }

      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        getRoles();
        handleCloseRoleModal();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const createUpdateFinanceCategory = async (formData) => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      const uid = formData?.uid || editFinanceCategoryData?.uid;
      // ส่งเฉพาะฟิลด์ที่ DTO รับ (payload เป็น strict schema)
      const body = {
        uid: uid || undefined,
        category_code: formData.category_code,
        category_name: formData.category_name,
        transaction_type: formData.transaction_type,
        description: formData.description,
        exclude_from_employee_report: !!formData.exclude_from_employee_report,
        is_active: !!formData.is_active,
      };

      const result = !uid
        ? await POST("v1/admin/finance-categories", body)
        : await PUT(`v1/admin/finance-categories/${uid}`, body);

      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        getFinanceCategories();
        handleCloseFinanceCategoryModal();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const deleteFinanceCategory = async (uid) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบรายการนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      const result = await DELETE(`v1/admin/finance-categories/${uid}`);
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        getFinanceCategories();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const renderCopyInput = (name, type = "text") => (
    <div className="stg-copy">
      <input
        type={type}
        name={name}
        className="form-control"
        value={companyForm[name] || ""}
        onChange={handleCompanyChange}
      />
      <button
        type="button"
        className="stg-copy-btn"
        onClick={() => copyText(companyForm[name] || "")}
        aria-label={`Copy ${name}`}
        title="Copy"
      >
        <span className="icon">{``}</span>
      </button>
    </div>
  );

  const expenseLimitOverrideCount = expenseLimitRows.filter((row) => String(row.input).trim() !== "").length;

  const selectedProvince = provinceData.find((item) => item.th === companyForm.province);
  const districtOptions = selectedProvince?.district?.map((item) => item.th) || [];
  const selectedDistrict = selectedProvince?.district?.find((item) => item.th === companyForm.district);
  const subDistrictOptions = selectedDistrict?.sub_district?.map((item) => item.th) || [];
  const selectedSubDistrict = selectedDistrict?.sub_district?.find((item) => item.th === companyForm.sub_district);
  const zipCodeOptions = selectedSubDistrict ? [String(selectedSubDistrict.code)] : [];
  const provinceSelectOptions = provinceOptions.map((province) => ({ value: province, label: province }));
  const districtSelectOptions = districtOptions.map((district) => ({ value: district, label: district }));
  const subDistrictSelectOptions = subDistrictOptions.map((subDistrict) => ({ value: subDistrict, label: subDistrict }));
  const zipCodeSelectOptions = zipCodeOptions.map((zipCode) => ({ value: zipCode, label: zipCode }));

  const roleSelectOptions = roles
    .filter((role) => role.name !== "super_user")
    .map((role) => ({ value: role.uid, label: role.name }));

  const employeeSelectOptions = employees.map((employee) => ({
    value: employee.uid,
    label: `${getEmployeeName(employee)}${employee.employee_code ? ` (${employee.employee_code})` : ""}`,
  }));

  const holidayYearOptions = (() => {
    const current = new Date().getFullYear();
    const list = [];
    for (let y = current + 1; y >= current - 3; y -= 1) list.push({ value: String(y), label: `ปี ${y}` });
    return list;
  })();

  // จัดวันหยุดเป็นราย 12 เดือน เพื่อแสดงเป็นปฏิทินย่อ
  const holidaysByMonth = THAI_MONTH_NAMES.map((label, index) => ({
    label,
    month: index,
    items: holidays
      .filter((item) => Number(String(item.holiday_date).slice(5, 7)) - 1 === index)
      .sort((a, b) => String(a.holiday_date).localeCompare(String(b.holiday_date))),
  }));

  const activeHolidayCount = holidays.filter((item) => item.is_active !== false).length;

  // แท็บย่อยของหมวดหมู่ทางการเงิน: กรองฝั่งหน้าเว็บจากรายการที่โหลดมาแล้ว ไม่ยิง API ซ้ำ
  const financeTypeTabs = [
    { key: "all", label: "ทั้งหมด", icon: "fa-solid fa-layer-group", count: financeCategories.length },
    { key: "income", label: "รายรับ", icon: "fa-solid fa-arrow-down", count: financeCategories.filter((item) => item.transaction_type === "income").length },
    { key: "expense", label: "รายจ่าย", icon: "fa-solid fa-arrow-up", count: financeCategories.filter((item) => item.transaction_type === "expense").length },
  ];
  const visibleFinanceCategories = financeTypeFilter === "all"
    ? financeCategories
    : financeCategories.filter((item) => item.transaction_type === financeTypeFilter);

  const visibleTabs = settingsTabs.filter((tab) => tab.key !== "drive-assets" || canManageDriveAssets);
  const currentTab = visibleTabs.find((tab) => tab.key === activeTab) || visibleTabs[0];

  // ตัวเลขกำกับในเมนูซ้าย (แท็บที่ไม่มีรายการให้นับจะไม่แสดง)
  const tabCounts = {
    "finance-categories": financeCategories.length,
    "expense-limits": expenseLimitRows.length,
    roles: roles.length,
    users: users.length,
    holidays: holidays.length,
  };

  return (
      <AppShell title={title} description={description}>
          <div className="stg row g-4">
              {/* เมนูซ้าย (จอเล็กจะกลายเป็นแถบแท็บเลื่อนแนวนอน) */}
              <div className="col-12 col-lg-4 col-xl-3">
                  <nav className="stg-nav settings-sidebar-sticky" aria-label="เมนูตั้งค่าระบบ">
                      <div className="stg-nav-head">
                          <p className="stg-eyebrow">Control Center</p>
                          <h2 className="stg-nav-title">ตั้งค่าระบบ</h2>
                      </div>
                      <div className="stg-nav-list">
                          {visibleTabs.map((tab) => (
                              <button
                                  key={tab.key}
                                  type="button"
                                  onClick={() => setActiveTab(tab.key)}
                                  className={`stg-nav-item ${activeTab === tab.key ? "is-active" : ""}`}
                                  aria-current={activeTab === tab.key ? "page" : undefined}
                              >
                                  <span className="stg-nav-icon"><i className={tab.icon} /></span>
                                  <span className="stg-nav-text">
                                      <span className="stg-nav-label">{tab.label}</span>
                                      <span className="stg-nav-hint">{tab.hint}</span>
                                  </span>
                                  {tabCounts[tab.key] !== undefined ? <span className="stg-nav-count">{tabCounts[tab.key]}</span> : null}
                              </button>
                          ))}
                      </div>
                  </nav>
              </div>

              {/* เนื้อหาของแท็บที่เลือก */}
              <div className="col-12 col-lg-8 col-xl-9">
                  <div className="stg-panel">
                      <div className="stg-panel-head">
                          <div className="stg-panel-intro">
                              <span className="stg-panel-icon"><i className={currentTab.icon} /></span>
                              <div style={{ minWidth: 0 }}>
                                  <p className="stg-eyebrow">{currentTab.eyebrow}</p>
                                  <h3 className="stg-panel-title">{currentTab.title}</h3>
                                  <p className="stg-panel-desc">
                                      {activeTab === "holidays"
                                          ? `ใช้เป็นฐานคำนวณวันทำงานของระบบการลาและเงินเดือน · ปี ${holidayYear} มี ${activeHolidayCount} วัน`
                                          : currentTab.description}
                                  </p>
                              </div>
                          </div>

                          <div className="stg-panel-actions">
                              {activeTab === "expense-limits" && (
                                  <button onClick={updateExpenseLimits} className="btn stg-btn stg-btn--primary">
                                      <i className="fa-solid fa-floppy-disk" />บันทึกการตั้งค่า
                                  </button>
                              )}
                              {activeTab === "roles" && (
                                  <>
                                      <button onClick={handleSyncPermissions} className="btn stg-btn stg-btn--ghost" title={`ซิงก์ ${ALL_PERMISSION_KEYS.length} รายการ`}>
                                          <i className="fa-solid fa-rotate" />ซิงก์รายการสิทธิ์
                                      </button>
                                      <button onClick={() => handleOpenRoleModal()} className="btn stg-btn stg-btn--primary">
                                          <i className="fa-solid fa-plus" />เพิ่มบทบาทใหม่
                                      </button>
                                  </>
                              )}
                              {activeTab === "users" && (
                                  <button onClick={() => handleOpenUserModal()} className="btn stg-btn stg-btn--primary">
                                      <i className="fa-solid fa-plus" />เพิ่มบัญชีผู้ใช้
                                  </button>
                              )}
                              {activeTab === "holidays" && (
                                  <>
                                      <div style={{ width: 130 }}>
                                          <Select className="form-control" value={holidayYear} options={holidayYearOptions} placeholder="เลือกปี" onChange={(value) => setHolidayYear(value)} />
                                      </div>
                                      <button onClick={() => handleOpenHolidayModal()} className="btn stg-btn stg-btn--primary">
                                          <i className="fa-solid fa-plus" />เพิ่มวันหยุด
                                      </button>
                                  </>
                              )}
                              {activeTab === "finance-categories" && (
                                  <button onClick={() => handleOpenFinanceCategoryModal()} className="btn stg-btn stg-btn--primary">
                                      <i className="fa-solid fa-plus" />เพิ่มหมวดหมู่
                                  </button>
                              )}
                          </div>
                      </div>

                      {/* key ทำให้เนื้อหา fade เข้าใหม่ทุกครั้งที่สลับแท็บ */}
                      <div className="stg-panel-body" key={activeTab}>
                      {activeTab === "company" && (
                              <form>
                                  <div className="stg-section">
                                      <div className="stg-section-head">
                                          <span className="stg-section-mark"><i className="fa-solid fa-id-card" /></span>
                                          <div>
                                              <h4 className="stg-section-title">ข้อมูลบริษัท</h4>
                                              <p className="stg-section-desc">ชื่อ เลขผู้เสียภาษี และช่องทางติดต่อ กดไอคอนด้านขวาเพื่อคัดลอก</p>
                                          </div>
                                      </div>
                                      <div className="row g-3">
                                          <div className="col-md-6">
                                              <label className="stg-label">ชื่อบริษัท (ภาษาไทย)</label>
                                              {renderCopyInput("name_th")}
                                          </div>
                                          <div className="col-md-6">
                                              <label className="stg-label">ชื่อบริษัท (ภาษาอังกฤษ)</label>
                                              {renderCopyInput("name_en")}
                                          </div>
                                          <div className="col-md-6">
                                              <label className="stg-label">เลขประจำตัวผู้เสียภาษี</label>
                                              {renderCopyInput("tax_number")}
                                          </div>
                                          <div className="col-md-6">
                                              <label className="stg-label">เบอร์โทรศัพท์</label>
                                              {renderCopyInput("phone")}
                                          </div>
                                          <div className="col-md-6">
                                              <label className="stg-label">อีเมล</label>
                                              {renderCopyInput("email", "email")}
                                          </div>
                                          <div className="col-md-6">
                                              <label className="stg-label">เว็บไซต์</label>
                                              {renderCopyInput("website")}
                                          </div>
                                      </div>
                                  </div>

                                  <div className="stg-section">
                                      <div className="stg-section-head">
                                          <span className="stg-section-mark"><i className="fa-solid fa-location-dot" /></span>
                                          <div>
                                              <h4 className="stg-section-title">ที่อยู่</h4>
                                              <p className="stg-section-desc">เลือกจังหวัด → อำเภอ → ตำบล ระบบจะเติมรหัสไปรษณีย์ให้</p>
                                          </div>
                                      </div>
                                      <div className="row g-3">
                                          <div className="col-12">
                                              <label className="stg-label">ที่อยู่</label>
                                              <textarea name="address" className="form-control" rows="3" value={companyForm.address} onChange={handleCompanyChange}></textarea>
                                          </div>
                                          <div className="col-sm-6 col-xl-3">
                                              <label className="stg-label">จังหวัด</label>
                                              <Select
                                                  className="form-control"
                                                  value={companyForm.province}
                                                  options={provinceSelectOptions}
                                                  placeholder="เลือกจังหวัด"
                                                  onChange={(value) => handleCompanyChange({ target: { name: "province", value } })}
                                              />
                                          </div>
                                          <div className="col-sm-6 col-xl-3">
                                              <label className="stg-label">เขต / อำเภอ</label>
                                              <Select
                                                  className="form-control"
                                                  value={companyForm.district}
                                                  options={districtSelectOptions}
                                                  placeholder="เลือกอำเภอ / เขต"
                                                  disabled={!companyForm.province}
                                                  onChange={(value) => handleCompanyChange({ target: { name: "district", value } })}
                                              />
                                          </div>
                                          <div className="col-sm-6 col-xl-3">
                                              <label className="stg-label">แขวง / ตำบล</label>
                                              <Select
                                                  className="form-control"
                                                  value={companyForm.sub_district}
                                                  options={subDistrictSelectOptions}
                                                  placeholder="เลือกตำบล / แขวง"
                                                  disabled={!companyForm.district}
                                                  onChange={(value) => handleCompanyChange({ target: { name: "sub_district", value } })}
                                              />
                                          </div>
                                          <div className="col-sm-6 col-xl-3">
                                              <label className="stg-label">รหัสไปรษณีย์</label>
                                              <Select
                                                  className="form-control"
                                                  value={companyForm.zip_code}
                                                  options={zipCodeSelectOptions}
                                                  placeholder="เลือกรหัสไปรษณีย์"
                                                  disabled={!companyForm.sub_district}
                                                  onChange={(value) => handleCompanyChange({ target: { name: "zip_code", value } })}
                                              />
                                          </div>
                                      </div>
                                  </div>

                                  <div className="stg-section">
                                      <div className="stg-section-head">
                                          <span className="stg-section-mark"><i className="fa-solid fa-building-columns" /></span>
                                          <div>
                                              <h4 className="stg-section-title">บัญชีธนาคาร</h4>
                                              <p className="stg-section-desc">บัญชีหลักของบริษัทสำหรับเอกสารการเงิน</p>
                                          </div>
                                      </div>
                                      <div className="row g-3">
                                          <div className="col-md-4">
                                              <label className="stg-label">ชื่อธนาคาร</label>
                                              <Select
                                                  className="form-control"
                                                  value={companyForm.bank_name}
                                                  options={bankOptions}
                                                  placeholder="เลือกธนาคาร"
                                                  onChange={(value) => handleCompanyChange({ target: { name: "bank_name", value } })}
                                              />
                                          </div>
                                          <div className="col-md-4">
                                              <label className="stg-label">เลขบัญชีธนาคาร</label>
                                              <input type="text" name="bank_account_number" className="form-control" value={companyForm.bank_account_number} onChange={handleCompanyChange} />
                                          </div>
                                          <div className="col-md-4">
                                              <label className="stg-label">ชื่อบัญชีธนาคาร</label>
                                              <input type="text" name="bank_account_name" className="form-control" value={companyForm.bank_account_name} onChange={handleCompanyChange} />
                                          </div>
                                      </div>
                                  </div>

                                  <div className="stg-savebar">
                                      <button type="button" className="btn stg-btn stg-btn--primary" onClick={updateCompanyData}>
                                          <i className="fa-solid fa-floppy-disk" />บันทึกการตั้งค่า
                                      </button>
                                  </div>
                              </form>
                      )}

                      {activeTab === "expense-limits" && (
                          <>
                              <div className="row g-3 mb-4">
                                  <div className="col-md-6">
                                      <div className="stg-section h-100">
                                          <label className="stg-label">วงเงินกลางของบริษัท (บาท/เดือน)</label>
                                          <input
                                              type="number"
                                              min="0"
                                              step="0.01"
                                              className="form-control"
                                              value={expenseLimitDefault}
                                              onChange={(event) => setExpenseLimitDefault(event.target.value)}
                                              placeholder="0 = ไม่จำกัดวงเงิน"
                                          />
                                          <div className="stg-help">กรอก 0 หากไม่ต้องการจำกัดวงเงิน</div>
                                      </div>
                                  </div>
                                  <div className="col-6 col-md-3">
                                      <div className="stg-stat stg-stat--dark">
                                          <div className="stg-stat-label">วงเงินกลาง</div>
                                          <div className="stg-stat-value">{formatLimitText(expenseLimitDefault)}</div>
                                          <div className="stg-stat-note">ต่อคน / เดือน</div>
                                      </div>
                                  </div>
                                  <div className="col-6 col-md-3">
                                      <div className="stg-stat">
                                          <div className="stg-stat-label">ตั้งค่าเฉพาะราย</div>
                                          <div className="stg-stat-value">{expenseLimitOverrideCount} <span className="fs-6 fw-normal text-secondary">/ {expenseLimitRows.length}</span></div>
                                          <div className="stg-stat-note">คน</div>
                                      </div>
                                  </div>
                              </div>


                              <div className="table-responsive table-mobile-cards settings-table-scroll stg-table-wrap" style={settingsTableScrollStyle}>
                                  <table className="table table-hover align-middle stg-table">
                                      <thead>
                                          <tr>
                                              <th>พนักงาน</th>
                                              <th>ตำแหน่ง</th>
                                              <th style={{ minWidth: 180 }}>วงเงินเฉพาะราย (บาท/เดือน)</th>
                                              <th className="text-end">วงเงินที่ใช้จริง</th>
                                              <th className="text-center">จัดการ</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {expenseLimitRows.length > 0 ? (
                                              expenseLimitRows.map((row) => {
                                                  const isOverride = String(row.input).trim() !== "";
                                                  const effectiveLimit = isOverride ? Number(row.input) : Number(expenseLimitDefault || 0);

                                                  return (
                                                      <tr key={row.employee?.uid}>
                                                          <td data-label="พนักงาน">
                                                              <div className="stg-cell-title">
                                                                  {getEmployeeName(row.employee)}
                                                                  {row.is_active === false ? <span className="stg-pill stg-pill--muted stg-pill--plain ms-2">ปิดใช้งาน</span> : null}
                                                              </div>
                                                              <div className="stg-cell-sub">{row.employee?.employee_code || "-"}</div>
                                                          </td>
                                                          <td data-label="ตำแหน่ง">
                                                              <div>{row.employee?.position || "-"}</div>
                                                              <div className="stg-cell-sub">{row.employee?.department || "-"}</div>
                                                          </td>
                                                          <td data-label="วงเงินเฉพาะราย">
                                                              <input
                                                                  type="number"
                                                                  min="0"
                                                                  step="0.01"
                                                                  className="form-control"
                                                                  value={row.input}
                                                                  onChange={(event) => handleExpenseLimitChange(row.employee?.uid, event.target.value)}
                                                                  placeholder="ว่าง = ใช้ค่ากลาง"
                                                              />
                                                          </td>
                                                          <td data-label="วงเงินที่ใช้จริง" className="text-end">
                                                              <div className="stg-cell-title mb-1">{formatLimitText(effectiveLimit)}</div>
                                                              <span className={`stg-pill stg-pill--plain ${isOverride ? "stg-pill--info" : "stg-pill--muted"}`}>
                                                                  {isOverride ? "เฉพาะราย" : "ค่ากลาง"}
                                                              </span>
                                                          </td>
                                                          <td data-label="จัดการ" className="text-center">
                                                              <button
                                                                  type="button"
                                                                  onClick={() => handleExpenseLimitChange(row.employee?.uid, "")}
                                                                  className="btn btn-sm stg-btn stg-btn--sm stg-btn--ghost"
                                                                  disabled={!isOverride}
                                                                  title="ใช้ค่ากลางของบริษัท"
                                                              >
                                                                  ใช้ค่ากลาง
                                                              </button>
                                                          </td>
                                                      </tr>
                                                  );
                                              })
                                          ) : (
                                              <tr>
                                                  <td colSpan="5" className="stg-empty">
                                                      <i className="fa-regular fa-folder-open" />ไม่พบข้อมูลพนักงาน
                                                  </td>
                                              </tr>
                                          )}
                                      </tbody>
                                  </table>
                              </div>
                          </>
                      )}

                      {activeTab === "roles" && (
                              <div className="table-responsive table-mobile-cards settings-table-scroll stg-table-wrap" style={settingsTableScrollStyle}>
                                  <table className="table table-hover align-middle stg-table">
                                      <thead>
                                          <tr>
                                              <th>ชื่อบทบาท</th>
                                              <th>ID</th>
                                              <th className="text-center">จำนวนสิทธิ์</th>
                                              <th className="text-center">จัดการ</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {roles.length > 0 ? (
                                              roles.map((item) => (
                                                  <tr key={item.uid}>
                                                      <td data-label="ชื่อบทบาท">
                                                          <span className="stg-cell-title">{item.name === SUPER_USER_ROLE ? "Super User" : item.name || "-"}</span>
                                                          {item.name === SUPER_USER_ROLE ? <span className="stg-pill stg-pill--gold stg-pill--plain ms-2"><i className="fa-solid fa-crown" />สิทธิ์สูงสุด</span> : null}
                                                      </td>
                                                      <td data-label="ID">
                                                          <span className="stg-code">{item.uid || "-"}</span>
                                                      </td>
                                                      <td data-label="จำนวนสิทธิ์" className="text-center">
                                                          {Array.isArray(item.permission) ? item.permission.length : "-"}
                                                      </td>
                                                      <td data-label="จัดการ" className="text-center">
                                                          <div className="d-flex justify-content-center gap-2">
                                                              {item.name !== SUPER_USER_ROLE || canEditSuperUserRole ? (
                                                                  <button onClick={() => handleOpenRoleModal(item)} className="stg-icon-btn" title="แก้ไข" aria-label="แก้ไข">
                                                                      <i className="fa-solid fa-pen" />
                                                                  </button>
                                                              ) : null}
                                                              {item.name === SUPER_USER_ROLE ? (
                                                                  <span
                                                                      className="stg-icon-btn is-locked"
                                                                      role="img"
                                                                      title={canEditSuperUserRole ? "บทบาทระบบ ลบไม่ได้" : "บทบาทระบบ แก้ไขได้เฉพาะผู้ใช้ประเภท Super User และลบไม่ได้"}
                                                                      aria-label="บทบาทระบบ ถูกล็อก"
                                                                  >
                                                                      <i className="fa-solid fa-lock" />
                                                                  </span>
                                                              ) : (
                                                                  <button onClick={() => deleteRole(item.uid)} className="stg-icon-btn stg-icon-btn--danger" title="ลบ" aria-label="ลบ">
                                                                      <i className="fa-solid fa-trash" />
                                                                  </button>
                                                              )}
                                                          </div>
                                                      </td>
                                                  </tr>
                                              ))
                                          ) : (
                                              <tr>
                                                  <td colSpan="4" className="stg-empty">
                                                      <i className="fa-regular fa-folder-open" />ไม่พบข้อมูลบทบาทผู้ใช้งาน
                                                  </td>
                                              </tr>
                                          )}
                                      </tbody>
                                  </table>
                              </div>
                      )}

                      {activeTab === "users" && (
                          <>

                              <div className="table-responsive table-mobile-cards settings-table-scroll stg-table-wrap" style={settingsTableScrollStyle}>
                                  <table className="table table-hover align-middle stg-table">
                                      <thead>
                                          <tr>
                                              <th>ผู้ใช้</th>
                                              <th>บทบาท</th>
                                              <th>ผูกกับพนักงาน</th>
                                              <th className="text-center">สถานะ</th>
                                              <th className="text-center">จัดการ</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {users.length > 0 ? (
                                              users.map((item) => (
                                                  <tr key={item.uid}>
                                                      <td data-label="ผู้ใช้">
                                                          <div>
                                                              <div className="stg-cell-title">{item.full_name_th || item.full_name_en || "-"}</div>
                                                              <div className="stg-cell-sub">{item.email || "-"}</div>
                                                              <div className="stg-cell-sub">{item.user_code || "-"} · {item.user_type || "-"}</div>
                                                          </div>
                                                      </td>
                                                      <td data-label="บทบาท">
                                                          <span className={`stg-pill stg-pill--plain ${item.role?.name === "super_user" ? "stg-pill--gold" : "stg-pill--info"}`}>
                                                              {item.role?.name === "super_user" ? "Super User" : item.role?.name || "-"}
                                                          </span>
                                                      </td>
                                                      <td data-label="ผูกกับพนักงาน">
                                                          {item.employee
                                                              ? `${item.employee.first_name || ""} ${item.employee.last_name || ""}`.trim() || item.employee.nickname || "-"
                                                              : <span className="stg-cell-sub">ยังไม่ผูก</span>}
                                                      </td>
                                                      <td data-label="สถานะ" className="text-center text-nowrap">
                                                          <span className={`stg-pill ${item.is_active ? "stg-pill--success" : "stg-pill--danger"}`}>
                                                              {item.is_active ? "ใช้งานอยู่" : "ระงับ"}
                                                          </span>
                                                      </td>
                                                      <td data-label="จัดการ" className="text-center">
                                                          <div className="d-flex justify-content-center gap-2">
                                                              <button onClick={() => handleOpenUserModal(item)} className="stg-icon-btn" title="แก้ไข" aria-label="แก้ไข">
                                                                  <i className="fa-solid fa-pen" />
                                                              </button>
                                                              <button onClick={() => deleteUser(item)} className="stg-icon-btn stg-icon-btn--danger" title="ลบ" aria-label="ลบ">
                                                                  <i className="fa-solid fa-trash" />
                                                              </button>
                                                          </div>
                                                      </td>
                                                  </tr>
                                              ))
                                          ) : (
                                              <tr>
                                                  <td colSpan="5" className="stg-empty">
                                                      <i className="fa-regular fa-folder-open" />ไม่พบบัญชีผู้ใช้
                                                  </td>
                                              </tr>
                                          )}
                                      </tbody>
                                  </table>
                              </div>
                          </>
                      )}

                      {activeTab === "drive-assets" && canManageDriveAssets && (
                          <>
                              <h6 className="fw-semibold text-dark mb-3"><i className="fa-solid fa-stamp me-2 text-primary" />ตราปั๊ม</h6>
                              <AssetLibrary type="stamp" />
                              <hr className="my-4" />
                              <h6 className="fw-semibold text-dark mb-3"><i className="fa-solid fa-signature me-2 text-primary" />ลายเซ็น</h6>
                              <AssetLibrary type="signature" />
                          </>
                      )}

                      {activeTab === "holidays" && (
                          <>
                              {/* มุมมองปฏิทินราย 12 เดือน กดที่รายการเพื่อแก้ไข */}
                              <div className="row g-3 mb-4">
                                  {holidaysByMonth.map((month) => (
                                      <div className="col-12 col-md-6 col-xl-4" key={month.label}>
                                          <div className={`stg-month ${month.items.length ? "has-items" : ""}`}>
                                              <div className="stg-month-head">
                                                  <div className="stg-month-name">{month.label}</div>
                                                  <span className={`stg-pill stg-pill--plain ${month.items.length ? "stg-pill--info" : "stg-pill--muted"}`}>
                                                      {month.items.length}
                                                  </span>
                                              </div>
                                              {month.items.length > 0 ? (
                                                  month.items.map((item) => {
                                                      const typeStyle = holidayTypeStyle[item.holiday_type] || holidayTypeStyle.public;
                                                      return (
                                                          <button
                                                              key={item.uid}
                                                              type="button"
                                                              onClick={() => handleOpenHolidayModal(item)}
                                                              className="stg-month-item"
                                                              style={{ opacity: item.is_active === false ? 0.45 : 1 }}
                                                          >
                                                              <span className="stg-month-day" style={typeStyle}>
                                                                  {String(item.holiday_date).slice(8, 10)}
                                                              </span>
                                                              <span className="small text-truncate" style={{ color: "#22384a" }}>{item.name}</span>
                                                          </button>
                                                      );
                                                  })
                                              ) : (
                                                  <div className="stg-cell-sub">ไม่มีวันหยุด</div>
                                              )}
                                          </div>
                                      </div>
                                  ))}
                              </div>

                              <div className="table-responsive table-mobile-cards stg-table-wrap">
                                  <table className="table table-hover align-middle stg-table">
                                      <thead>
                                          <tr>
                                              <th>วันที่</th>
                                              <th>ชื่อวันหยุด</th>
                                              <th>ประเภท</th>
                                              <th className="text-center">สถานะ</th>
                                              <th className="text-center">จัดการ</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {holidays.length > 0 ? (
                                              holidays.map((item) => {
                                                  const typeStyle = holidayTypeStyle[item.holiday_type] || holidayTypeStyle.public;
                                                  return (
                                                      <tr key={item.uid}>
                                                          <td data-label="วันที่" className="text-nowrap">{format_date(item.holiday_date, "dd/mm/yyyy")}</td>
                                                          <td data-label="ชื่อวันหยุด">
                                                              <div className="stg-cell-title">{item.name}</div>
                                                              {item.description ? <div className="stg-cell-sub">{item.description}</div> : null}
                                                          </td>
                                                          <td data-label="ประเภท" className="text-nowrap">
                                                              <span className="stg-pill stg-pill--plain" style={typeStyle}>
                                                                  {holidayTypeOptions.find((option) => option.value === item.holiday_type)?.label || item.holiday_type}
                                                              </span>
                                                          </td>
                                                          <td data-label="สถานะ" className="text-center text-nowrap">
                                                              <span className={`stg-pill ${item.is_active !== false ? "stg-pill--success" : "stg-pill--muted"}`}>
                                                                  {item.is_active !== false ? "ใช้งาน" : "ปิด"}
                                                              </span>
                                                          </td>
                                                          <td data-label="จัดการ" className="text-center">
                                                              <div className="d-flex justify-content-center gap-2">
                                                                  <button onClick={() => handleOpenHolidayModal(item)} className="stg-icon-btn" title="แก้ไข" aria-label="แก้ไข">
                                                                      <i className="fa-solid fa-pen" />
                                                                  </button>
                                                                  <button onClick={() => deleteHoliday(item)} className="stg-icon-btn stg-icon-btn--danger" title="ลบ" aria-label="ลบ">
                                                                      <i className="fa-solid fa-trash" />
                                                                  </button>
                                                              </div>
                                                          </td>
                                                      </tr>
                                                  );
                                              })
                                          ) : (
                                              <tr>
                                                  <td colSpan="5" className="stg-empty">
                                                      <i className="fa-regular fa-calendar-xmark" />ยังไม่มีวันหยุดในปี {holidayYear}
                                                  </td>
                                              </tr>
                                          )}
                                      </tbody>
                                  </table>
                              </div>
                          </>
                      )}

                      {activeTab === "finance-categories" && (
                          <>
                              <div className="stg-segment mb-3" role="tablist" aria-label="ประเภทหมวดหมู่">
                                  {financeTypeTabs.map((tab) => (
                                      <button
                                          key={tab.key}
                                          type="button"
                                          role="tab"
                                          aria-selected={financeTypeFilter === tab.key}
                                          onClick={() => setFinanceTypeFilter(tab.key)}
                                          className={`stg-segment-item stg-segment-item--${tab.key} ${financeTypeFilter === tab.key ? "is-active" : ""}`}
                                      >
                                          <i className={tab.icon} />
                                          {tab.label}
                                          <span className="stg-segment-count">{tab.count}</span>
                                      </button>
                                  ))}
                              </div>

                              <div className="table-responsive table-mobile-cards settings-table-scroll stg-table-wrap" style={settingsTableScrollStyle}>
                                  <table className="table table-hover align-middle stg-table">
                                      <thead>
                                          <tr>
                                              <th>รหัสหมวดหมู่</th>
                                              <th style={{ width: "100%" }}>ชื่อหมวดหมู่</th>
                                              <th>ประเภท</th>
                                              <th className="text-center">สถานะ</th>
                                              <th className="text-center">จัดการ</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {visibleFinanceCategories.length > 0 ? (
                                              visibleFinanceCategories.map((item) => (
                                                  <tr key={item.uid}>
                                                      <td data-label="รหัสหมวดหมู่" className="text-nowrap">
                                                          <span className="d-inline-flex align-items-center gap-2">
                                                              <span className="stg-code">{item.category_code || "-"}</span>
                                                              {/* หมวดหมู่ที่ไม่นับรวมในรายงานธุรกรรมการเงินพนักงาน */}
                                                              {item.exclude_from_employee_report ? (
                                                                  <span
                                                                      className="stg-flag stg-flag--violet"
                                                                      title="ไม่รวมในรายงานธุรกรรมการเงินพนักงาน"
                                                                      aria-label="ไม่รวมในรายงานธุรกรรมการเงินพนักงาน"
                                                                      role="img"
                                                                  >
                                                                      <i className="fa-solid fa-user-slash" />
                                                                  </span>
                                                              ) : null}
                                                          </span>
                                                      </td>
                                                      <td data-label="ชื่อหมวดหมู่" className="stg-cell-wrap">
                                                          <div className="stg-cell-title">{item.category_name || "-"}</div>
                                                      </td>
                                                      <td data-label="ประเภท">
                                                          {item.transaction_type === "income" ? (
                                                              <span className="stg-pill stg-pill--success stg-pill--plain"><i className="fa-solid fa-arrow-down" />รายรับ</span>
                                                          ) : item.transaction_type === "expense" ? (
                                                              <span className="stg-pill stg-pill--danger stg-pill--plain"><i className="fa-solid fa-arrow-up" />รายจ่าย</span>
                                                          ) : "-"}
                                                      </td>
                                                      <td data-label="สถานะ" className="text-center">
                                                          <span className={`stg-pill ${item.is_active ? "stg-pill--success" : "stg-pill--muted"}`}>
                                                              {item.is_active ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                                                          </span>
                                                      </td>
                                                      <td data-label="จัดการ" className="text-center">
                                                          <div className="d-flex justify-content-center gap-2">
                                                              <button onClick={() => handleOpenFinanceCategoryModal(item)} className="stg-icon-btn" title="แก้ไข" aria-label="แก้ไข">
                                                                  <i className="fa-solid fa-pen" />
                                                              </button>
                                                              <button onClick={() => deleteFinanceCategory(item.uid)} className="stg-icon-btn stg-icon-btn--danger" title="ลบ" aria-label="ลบ">
                                                                  <i className="fa-solid fa-trash" />
                                                              </button>
                                                          </div>
                                                      </td>
                                                  </tr>
                                              ))
                                          ) : (
                                              <tr>
                                                  <td colSpan="5" className="stg-empty">
                                                      <i className="fa-regular fa-folder-open" />
                                                      {financeTypeFilter === "all" ? "ไม่พบข้อมูลหมวดหมู่ทางการเงิน" : `ยังไม่มีหมวดหมู่${financeTypeFilter === "income" ? "รายรับ" : "รายจ่าย"}`}
                                                  </td>
                                              </tr>
                                          )}
                                      </tbody>
                                  </table>
                              </div>
                          </>
                      )}
                      </div>
                  </div>
              </div>
          </div>

          <RoleModal show={showRoleModal} onHide={handleCloseRoleModal} editData={editRoleData} onSave={handleRoleSave} />
          <HolidayModal show={showHolidayModal} onHide={handleCloseHolidayModal} editData={editHolidayData} onSave={createUpdateHoliday} />
          <UserModal
            show={showUserModal}
            onHide={handleCloseUserModal}
            editData={editUserData}
            onSave={createUpdateUser}
            roleOptions={roleSelectOptions}
            employeeOptions={employeeSelectOptions}
          />
          <FinanceCategoryModal show={showFinanceCategoryModal} onHide={handleCloseFinanceCategoryModal} editData={editFinanceCategoryData} onSave={createUpdateFinanceCategory} />
      </AppShell>
  );
}
